import { deleteApiCall, getApiCall, postApiCall } from '../utils/Api';

export const getChannelByFilmmaker = async () => {
  const result = await getApiCall(`/filmmaker/channel/detail`);
  return result.data;
};

export const getChannelNumbers = async () => {
  const result = await getApiCall(`/filmmaker/channel/get-numbers`);
  return result.data;
};

export const createChannel = async (data) => {
  const result = await postApiCall(`/filmmaker/channel/create`, data, true);
  return result.data;
};

export const getChannelVideos = async (id, page) => {
  const result = await getApiCall(`/filmmaker/channel/${id}/channel-videos?page=${page}`);
  return result.data;
};

export const getChannelAllVideos = async (id) => {
  const result = await getApiCall(`/filmmaker/channel/${id}/all-channel-videos`);
  return result.data;
};

export const assignVideos = async (id, data) => {
  const result = await postApiCall(`/filmmaker/channel/${id}/assign-video`, data, true);
  return result.data;
};

export const removeAssignedVideo = async (id, videoId) => {
  const result = await deleteApiCall(`/filmmaker/channel/${id}/channel-video/${videoId}/remove`);
  return result.data;
};

export const updateProgramOrder = async (id, data) => {
  const result = await postApiCall(`/filmmaker/channel/${id}/update-program-order`, data, true);
  return result.data;
};

export const updateChannel = async (id, data) => {
  const result = await postApiCall(`/filmmaker/channel/${id}/update`, data, true);
  return result.data;
};
